import type { MultiSelectValue } from '@app/shared/components/MultiSelect/types';

export type Int32ItemsFilter = {
  OuterInclude: boolean;
  InnerInclude: boolean | null;
  ItemIds: number[] | null;
};

export const msToInt32ItemsFilters = (
  ms: MultiSelectValue | null | undefined
): Int32ItemsFilter[] | null => {
  if (!ms?.groups?.length) return null;

  const filtered = ms.groups.filter((g) => g.selectedValues.length > 0);
  if (filtered.length === 0) return null;

  return filtered.map((g, idx): Int32ItemsFilter => {
    const inner = g.logic === 'AND' ? true : g.logic === 'OR' ? false : null;

    const outer =
      idx === 0 ? true : g.relationToPrev ? g.relationToPrev === 'AND' : true;

    const ids = g.selectedValues
      .map((v) => Number(v))
      .filter((n) => Number.isFinite(n));

    return {
      OuterInclude: outer,
      InnerInclude: inner,
      ItemIds: ids.length ? ids : null,
    };
  });
};
